/* JV Furniture: smooth reveal-on-scroll. One IntersectionObserver, no scroll listeners, no layout reads while scrolling. */
(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var main = document.getElementById('MainContent');
  if (!main) return;

  var template = main.getAttribute('data-template') || '';
  var product = /^product/.test(template);

  /* Never animate the buy box, gallery or cart: they are what people came for and must appear instantly. */
  if (/^(cart|gift_card|password|404)/.test(template)) return;

  var SELECTORS = product
    ? [
        ['.product-recommendations .resource-list__item', ''],
        ['.product-recommendations h2', 'soft']
      ]
    : [
        ['.product-grid__item', ''],
        ['.resource-list__item', ''],
        ['.collection-card', ''],
        ['.collection-list__item', ''],
        ['.media-with-content', 'media'],
        ['.jv-values li', ''],
        ['.featured-blog-posts-card', ''],
        ['.blog-posts-card', ''],
        ['.layered-slideshow', 'soft'],
        ['.section-resource-list__header', 'soft'],
        ['.shopify-section:not(:first-child) :is(h2, .h2)', 'soft'],
        ['.shopify-section:not(:first-child) .text-block.rte', 'soft']
      ];

  var seen = new WeakSet();
  var io = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  var timer = 0;

  function done(el) {
    el.removeAttribute('data-jv-reveal');
    el.classList.remove('jv-in');
    el.style.removeProperty('--jv-delay');
  }

  function onIntersect(entries) {
    var visible = entries.filter(function (e) {
      return e.isIntersecting;
    });
    if (!visible.length) return;
    visible.sort(function (a, b) {
      var ra = a.boundingClientRect;
      var rb = b.boundingClientRect;
      return ra.top - rb.top || ra.left - rb.left;
    });
    visible.forEach(function (entry, i) {
      var el = entry.target;
      io.unobserve(el);
      el.style.setProperty('--jv-delay', Math.min(i, 5) * 80 + 'ms');
      window.requestAnimationFrame(function () {
        el.classList.add('jv-in');
      });
      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        done(el);
      };
      el.addEventListener('transitionend', function (ev) {
        if (ev.target === el && ev.propertyName === 'opacity') finish();
      });
      window.setTimeout(finish, 2600);
    });
  }

  function prepare() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var found = [];
    SELECTORS.forEach(function (pair) {
      main.querySelectorAll(pair[0]).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        found.push([el, pair[1], el.getBoundingClientRect()]);
      });
    });
    found.forEach(function (item) {
      var rect = item[2];
      /* Anything already on screen (or above it) is left alone so nothing important is ever hidden at first paint. */
      if (rect.bottom < 0 || rect.top < vh * 0.92) return;
      item[0].setAttribute('data-jv-reveal', item[1]);
      io.observe(item[0]);
    });
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(prepare, 160);
  }

  function start() {
    prepare();
    new MutationObserver(schedule).observe(main, { childList: true, subtree: true });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-jv-reveal]').forEach(done);
  });

  if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1500 });
  else window.setTimeout(start, 300);
})();
